function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M256 32L32 128v224l224 128 224-128V128L256 32zm198 102.2L256 246 59.2 133.8 256 48l198 86.2zM48 145.8L248 260v197L48 342.7V145.8zM264 457V260l200-113.1v195.8L264 457z"
});

const SvgIosCubeOutline = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosCubeOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-cube-outline.be55fb57.svg";
export { ForwardRef as ReactComponent };